import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/Sidebar.css';
import { FiLogOut, FiCalendar, FiUser, FiHome, FiFileText, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { PiDog } from "react-icons/pi";
import { AiOutlineTeam, AiOutlineCheck } from "react-icons/ai";
import { MdOutlineTask, MdSchool } from "react-icons/md";
import { BsClipboardCheck } from "react-icons/bs";

const TrainerSidebar = ({ trainer, isCollapsed, onToggleCollapse, activeRoute }) => {
    const navigate = useNavigate();

    // Helper function to check if route is active
    const isRouteActive = (route) => {
        if (Array.isArray(route)) {
            return route.some(r => activeRoute?.includes(r));
        }
        return activeRoute?.includes(route);
    };

    const handleLogout = () => {
        localStorage.removeItem('jwt');
        navigate('/');
    };

    // Display trainer's name
    const displayName = trainer?.firstName && trainer?.lastName
        ? `${trainer.firstName} ${trainer.lastName}`
        : trainer?.username || 'Trainer';

    return (
        <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
            {/* Collapse/Expand Toggle Button */}
            <button
                className="collapse-toggle"
                onClick={onToggleCollapse}
                title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
                {isCollapsed ? <FiChevronRight /> : <FiChevronLeft />}
            </button>

            {!isCollapsed && (
                <>
                    <div className="profile-section">
                        <div className="profile-icon">
                            <span>{displayName.charAt(0)}</span>
                        </div>
                        <p>{displayName}</p>
                    </div>
                    <nav className="nav-section">
                        <ul>
                            <li>
                                <button
                                    className={`nav-button ${isRouteActive('/dashboard') ? 'active' : ''}`}
                                    onClick={() => navigate('/dashboard')}
                                >
                                    <FiHome /> Dashboard
                                </button>
                            </li>
                            <li>
                                <button
                                    className={`nav-button ${isRouteActive('/podopieczni') ? 'active' : ''}`}
                                    onClick={() => navigate('/podopieczni')}
                                >
                                    <PiDog /> Podopieczni
                                </button>
                            </li>
                            <li>
                                <button
                                    className={`nav-button ${isRouteActive('/owners') ? 'active' : ''}`}
                                    onClick={() => navigate('/owners/all')}
                                >
                                    <AiOutlineTeam /> Właściciele
                                </button>
                            </li>
                            <li>
                                <button
                                    className={`nav-button ${isRouteActive('/exercises') ? 'active' : ''}`}
                                    onClick={() => navigate('/exercises')}
                                >
                                    <MdOutlineTask /> Ćwiczenia
                                </button>
                            </li>
                            <li>
                                <button
                                    className={`nav-button ${isRouteActive('/reports') ? 'active' : ''}`}
                                    onClick={() => navigate('/reports')}
                                >
                                    <FiFileText /> Raporty
                                </button>
                            </li>
                            <li>
                                <button
                                    className={`nav-button ${isRouteActive('/survey') ? 'active' : ''}`}
                                    onClick={() => navigate(`/survey/school/${trainer?.schoolId}/all`)}
                                >
                                    <BsClipboardCheck /> Ankiety
                                </button>
                            </li>
                            <li>
                                <button
                                    className={`nav-button ${isRouteActive('/calendar') ? 'active' : ''}`}
                                    onClick={() => navigate('/calendar')}
                                >
                                    <FiCalendar /> Kalendarz
                                </button>
                            </li>
                            <li>
                                <button
                                    className={`nav-button ${isRouteActive('/trainings/confirmed') ? 'active' : ''}`}
                                    onClick={() => navigate('/trainings/confirmed')}
                                >
                                    <AiOutlineCheck /> Treningi
                                </button>
                            </li>
                            <li>
                                <button
                                    className={`nav-button ${isRouteActive('/school/details') ? 'active' : ''}`}
                                    onClick={() => navigate('/school/details')}
                                >
                                    <MdSchool /> Szkoła
                                </button>
                            </li>
                            <li>
                                <button
                                    className={`nav-button ${isRouteActive('/trainer/account') ? 'active' : ''}`}
                                    onClick={() => navigate('/trainer/account')}
                                >
                                    <FiUser /> Moje konto
                                </button>
                            </li>
                        </ul>
                    </nav>
                    <button className="logout-button" onClick={handleLogout}>
                        <FiLogOut className="logout-icon" /> Wyloguj się
                    </button>
                </>
            )}

            {/* Collapsed state - only show icons */}
            {isCollapsed && (
                <nav className="nav-section-collapsed">
                    <ul>
                        <li>
                            <button
                                className={`nav-button-collapsed ${isRouteActive('/dashboard') ? 'active' : ''}`}
                                onClick={() => navigate('/dashboard')}
                                title="Dashboard"
                            >
                                <FiHome />
                            </button>
                        </li>
                        <li>
                            <button
                                className={`nav-button-collapsed ${isRouteActive('/podopieczni') ? 'active' : ''}`}
                                onClick={() => navigate('/podopieczni')}
                                title="Podopieczni"
                            >
                                <PiDog />
                            </button>
                        </li>
                        <li>
                            <button
                                className={`nav-button-collapsed ${isRouteActive('/owners') ? 'active' : ''}`}
                                onClick={() => navigate('/owners/all')}
                                title="Właściciele"
                            >
                                <AiOutlineTeam />
                            </button>
                        </li>
                        <li>
                            <button
                                className={`nav-button-collapsed ${isRouteActive('/exercises') ? 'active' : ''}`}
                                onClick={() => navigate('/exercises')}
                                title="Ćwiczenia"
                            >
                                <MdOutlineTask />
                            </button>
                        </li>
                        <li>
                            <button
                                className={`nav-button-collapsed ${isRouteActive('/reports') ? 'active' : ''}`}
                                onClick={() => navigate('/reports')}
                                title="Raporty"
                            >
                                <FiFileText />
                            </button>
                        </li>
                        <li>
                            <button
                                className={`nav-button-collapsed ${isRouteActive('/survey') ? 'active' : ''}`}
                                onClick={() => navigate(`/survey/school/${trainer?.schoolId}/all`)}
                                title="Ankiety"
                            >
                                <BsClipboardCheck />
                            </button>
                        </li>
                        <li>
                            <button
                                className={`nav-button-collapsed ${isRouteActive('/calendar') ? 'active' : ''}`}
                                onClick={() => navigate('/calendar')}
                                title="Kalendarz"
                            >
                                <FiCalendar />
                            </button>
                        </li>
                        <li>
                            <button
                                className={`nav-button-collapsed ${isRouteActive('/trainings/confirmed') ? 'active' : ''}`}
                                onClick={() => navigate('/trainings/confirmed')}
                                title="Treningi"
                            >
                                <AiOutlineCheck />
                            </button>
                        </li>
                        <li>
                            <button
                                className={`nav-button-collapsed ${isRouteActive('/school/details') ? 'active' : ''}`}
                                onClick={() => navigate('/school/details')}
                                title="Szkoła"
                            >
                                <MdSchool />
                            </button>
                        </li>
                        <li>
                            <button
                                className={`nav-button-collapsed ${isRouteActive('/trainer/account') ? 'active' : ''}`}
                                onClick={() => navigate('/trainer/account')}
                                title="Moje konto"
                            >
                                <FiUser />
                            </button>
                        </li>
                    </ul>
                    <button
                        className="logout-button-collapsed"
                        onClick={handleLogout}
                        title="Wyloguj się"
                    >
                        <FiLogOut />
                    </button>
                </nav>
            )}
        </aside>
    );
};

export default TrainerSidebar;